import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PropertiesTitle } from '@common/components/PropertiesTitle';
import { useCallback } from 'react';

import { SIMULATION_EDIT_ERROR } from '../../../helpers/constants';
import { CloseButton } from '@/modules/simulation/components/CloseButton';
import { Status } from '@/modules/simulation/components/Status';

type Props = {
  value: string;
  onChange: (name: string) => void;
  onCloseClick: () => void;
};

export function Header({ value, onChange, onCloseClick }: Props) {
  const { t } = useTranslation('interface');

  const onNameChange = useCallback(
    (value: string) => {
      onChange(value);
    },
    [onChange],
  );

  const nameError = !value?.length && SIMULATION_EDIT_ERROR.NAME_TOO_SHORT;

  return (
    <Stack sx={{ px: 2 }}>
      <Stack direction='row' alignItems='center' justifyContent='space-between' gap={1}>
        <Status status='DRAFT' isGroup={false} />
        <CloseButton onCloseClick={onCloseClick} />
      </Stack>
      <PropertiesTitle
        sx={{ mt: 1 }}
        value={value}
        editable
        onChange={onNameChange}
        error={!!nameError}
        helperText={nameError ? t(nameError.i18nMessageKey) : ''}
      />
    </Stack>
  );
}
